import * as React from 'react';
import { useCurrentFluent2Theme } from '../../../hooks/styling';
import { FluentIconNames } from '../../common/fluent-icon-names';
import { useWarningToastContext } from '../hooks/toast-hooks';
import { BaseToast } from './base-toast';

export const WarningToast: React.FC = React.memo(() => {
    const { isOpen, properties, closeSurface } = useWarningToastContext();
    const theme = useCurrentFluent2Theme();
    return (
        <BaseToast
            isOpen={isOpen}
            title={properties?.title}
            autoHideDelay={properties?.autoHideDelay}
            devBoxName={properties?.devBoxName}
            iconName={FluentIconNames.Warning}
            backgroundColor={theme.colorNeutralBackground3}
            onDismiss={closeSurface}
        >
            {properties?.children}
        </BaseToast>
    );
});
